import {reducer} from '../helpers'

import * as lookbuilderActions from '../../actions/lookbuilder'
import {ApiRequestStates} from '../../const'

const initialProductsByCategory = {
  'suits-tuxedos': {},
  shirts: {},
  neckwear: {},
  shoes: {},
  'belts-suspenders': {},
  'pocket-squares': {},
  'vests-cummerbunds': {},
  cufflinks: {},
  studs: {},
  'tie-clips': {},
}

const initialState = {
  queuedProductSlugsToFetch: [],
  fetchDefaultProductSlugsStatus: ApiRequestStates.IDLE,
  productsByCategory: initialProductsByCategory,
  allProductCategories: [
    'suits-tuxedos',
    'shirts',
    'neckwear',
    'shoes',
    'belts-suspenders',
    'pocket-squares',
    'vests-cummerbunds',
    'cufflinks',
    'studs',
    'tie-clips',
  ],
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case lookbuilderActions.RESET_LOOKBUILDER_LOOK:
      return {
        ...state,
        productsByCategory: initialProductsByCategory,
      }
    case lookbuilderActions.UPDATE_PLANNER_CATEGORY:
      return {
        ...state,
        productsByCategory: {
          ...state.productsByCategory,
          [payload.category]: payload.product,
        },
      }
    case lookbuilderActions.SELECT_TRANSACTION_TYPE:
      return {
        ...state,
        productsByCategory: {
          ...state.productsByCategory,
          [payload.category]: {
            ...state.productsByCategory[payload.category],
            transactionType: payload.transactionType,
          },
        },
      }
    case lookbuilderActions.QUEUE_LOOKBUILDER_PRODUCTS:
      return {queuedProductSlugsToFetch: payload.products}
    case lookbuilderActions.GET_PRODUCT_SETS_PENDING:
      return {
        ...state,
        fetchDefaultProductSlugsStatus: ApiRequestStates.PENDING,
      }
    case lookbuilderActions.GET_PRODUCT_SETS_SUCCESS:
      return {
        ...state,
        fetchDefaultProductSlugsStatus: ApiRequestStates.SUCCESS,
        productsByCategory: {
          ...state.productsByCategory,
          ...payload.productsByCategory,
        },
        queuedProductSlugsToFetch: [],
      }
    case lookbuilderActions.GET_PRODUCT_SETS_FAILURE:
      return {
        ...state,
        fetchDefaultProductSlugsStatus: ApiRequestStates.ERROR,
      }
    default:
      return null
  }
})
